import styled, { keyframes } from "styled-components";

export const shimmer = keyframes`
  0% { background-position: 150% 0;  }
  100% { background-position: -50% 0; }
`;

type ISize = `${number}${"px" | "rem" | "%"}`;

export interface ILoadingSkeletonBaseStylesProps {
  width?: ISize;
  size?: ISize;
  height?: ISize;
}

export const LoadingSkeletonBaseStyles = styled.div<ILoadingSkeletonBaseStylesProps>`
  background: linear-gradient(
    90deg,
    ${({ theme }) => (theme.mode === "dark" ? "#2F2F2F" : "#BEBEBE")} 25%,
    ${({ theme }) => (theme.mode === "dark" ? "#424242" : "#CECECE")} 50%,
    ${({ theme }) => (theme.mode === "dark" ? "#2F2F2F" : "#BEBEBE")} 75%
  );
  background-size: 200% 100%;

  animation: ${shimmer} 1.5s infinite ease-in-out;

  border-radius: 4px;
`;
